import { gql } from '@apollo/client';

export const ADD_SITE = gql`
  mutation AddSite($data: CreateSiteInput!) {
    createSite(data: $data) {
      id
    }
  }
`;
